import { Component } from '@angular/core';

@Component({
  selector: 'app-block-steps',
  templateUrl: './block-steps.component.html',
  styleUrls: ['./block-steps.component.scss']
})
export class BlockStepsComponent {

}
